<template>
    <div class="font-main-regular" data-cy="container_app_root">
        <router-view />
    </div>
</template>
<script>
import ConfigManager from "@/config/ConfigManager.js";
//store
import SideMenuStore from "@/store/SideMenuStore.js";
import AccountStore from "@/store/AccountStore.js";

export default {
    created: function () {
        console.log("run local environment", ConfigManager.getApi());
        AccountStore.methods.init();
    },
    provide: {
        SideMenuStore: SideMenuStore,
        AccountStore: AccountStore,
    }
}
</script>
<style lang="scss">
@import "./style/base/base.scss";
@import "./style/main.scss";

</style>
